import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SmoothScroll, ScrollToTop } from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Mills from "@/pages/Mills";
import Industries from "@/pages/Industries";
import Sustainability from "@/pages/Sustainability";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App paper-grain min-h-screen bg-paper">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/mills" element={<Mills />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/sustainability" element={<Sustainability />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFab />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
